class HistoryState {
    constructor(){
        this._stateFromSearch = this._parseSearchStringToState(window.location.search);
    }

    _parseSearchStringToState(search){
        if(!search){
            return {};
        }
        return search.replace('?','')
        .split('&')
        .map(s => s.split('='))
        .reduce((p,c) => {
            p[c[0]] = c[1];
            return p;
        }, {});
    }

    pushState(key, value){
        this._stateFromSearch[key] = `${value}`;
        const search = Object.keys(this._stateFromSearch).map(k => `${k}=${this._stateFromSearch[k]}`).join('&');
        window.history.pushState(this._stateFromSearch, '', `?${search}`);
    }

    get getStateFromSearch(){
        return this._stateFromSearch;
    }

    clearState(){
        this._stateFromSearch = {};
    }
}

export default (() => {
    const HS = new HistoryState();
    return HS;
})();